import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=e283075e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ros-kepler-tecowebsite(r项目开发者平台)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e283075e"]])

export default __exports__